import CityAirportTemplate from '../../components/templates/CityAirportTemplate';

export default function TaxiMaarssenRotterdamAirportPage() {
  return (
    <CityAirportTemplate
      city="Maarssen"
      airport="rotterdam"
      airportName="Rotterdam The Hague Airport"
      price={72.50}
      distance="60 km"
      duration="50-55 minuten"
    />
  );
}
